﻿import { ServiceOptions, serviceRequest } from "@serenity-is/corelib";
import { SupportTicketSendEmailRequest } from "../SupportTicketSendEmailRequest";
import { SupportTicketSendEmailResponse } from "../SupportTicketSendEmailResponse";

export namespace SupportTicketService {
    export const baseUrl = 'SupportTicket';

    export declare function SendEmail(request: SupportTicketSendEmailRequest, onSuccess?: (response: SupportTicketSendEmailResponse) => void, opt?: ServiceOptions<any>): PromiseLike<SupportTicketSendEmailResponse>;

    export const Methods = {
        SendEmail: "SupportTicket/SendEmail"
    } as const;

    [
        'SendEmail'
    ].forEach(x => {
        (<any>SupportTicketService)[x] = function (r, s, o) {
            return serviceRequest(baseUrl + '/' + x, r, s, o);
        };
    });
}